module.exports = __webpack_public_path__ + "img/trash.817692bf.svg";